import type { ID } from '@adornis/baseql/baseqlTypes.js';
import { BaseError, type BaseErrorExtensions } from '@adornis/validation/errors/BaseError.js';

export class RegistrationCollisionsError extends BaseError {
  static override _class = 'RegistrationCollisionsError';

  workshopIDs?: Array<string | ID>;

  public constructor(workshopIDs: Array<string | ID>, extensions: BaseErrorExtensions = {}) {
    extensions.workshopIDs = workshopIDs;
    super('RegistrationCollisionsError', extensions);
    this.workshopIDs = workshopIDs;
  }

  static override createFromDetails(message: string, extensions: BaseErrorExtensions) {
    return new this(extensions.workshopIDs, extensions);
  }
}
